export default "__VITE_ASSET__DahV8Hsw__"